import { useEffect, useState } from 'react';

/**
 * Hook to determine when the gtag function is ready for use.
 *
 * With GTM, the gtag function is defined in the init script and available
 * immediately. This hook checks that the dataLayer and gtag are present.
 *
 * @returns boolean indicating if gtag is initialized and ready
 */
export const useGTag = () => {
  const [isGTagReady, setGTagReady] = useState(false);

  useEffect(() => {
    // gtag is defined in the beforeInteractive init script,
    // so it should be available by the time effects run.
    if (typeof window.gtag === 'function' && window.dataLayer) {
      setGTagReady(true);
    }
  }, []);

  return isGTagReady;
};
